import "../styles/Footer.css"

interface FooterButton {
  text: string;
  color?: "green" | "red" | "secondary";
  onClick: () => void;
}

interface FooterProps {
  leftButtons?: FooterButton[];
  rightButton?: FooterButton;
}

const Footer: React.FC<FooterProps> = ({ leftButtons = [], rightButton }) => {
  const getColorClass = (color?: string) => {
    switch (color) {
      case "red":
        return "footer-btn-red";
      case "green":
        return "footer-btn-green";
      default:
        return "footer-btn-secondary";
    }
  };

  return (
    <div className="footer-container">
      {leftButtons.map((btn, idx) => (
        <button
          key={idx}
          className={`footer-btn ${getColorClass(btn.color)}`}
          onClick={btn.onClick}
        >
          {btn.text}
        </button>
      ))}

      {rightButton && (
        <button
          className={`footer-btn ${getColorClass(rightButton.color)}`}
          onClick={rightButton.onClick}
        >
          {rightButton.text}
        </button>
      )}
    </div>
  );
};

export default Footer;
